export const GET_SETTINGS_STARTED = 'GET_SETTINGS_STARTED';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_ERROR = 'GET_SETTINGS_ERROR';
